import styled, { css, hueToColor } from '@benzinga/themetron';
import { WidgetLinkHue } from '@benzinga/widget-linking';
import { useTickerLinking } from './useTickerLinking';
import React from 'react';
import { SearchTag, SearchTagIcon } from '../SearchBar';
import { TooltipButton } from '@benzinga/widget-tools';
import { isString } from '@benzinga/utils';
import { SearchModule, useLinkingSearchModule } from '../Modules';
import { LinkingSearchItem, SearchItem } from '@benzinga/search-modules';
import { SmallSearch } from '@benzinga/themed-icons';

export interface SearchLinkingIconProps {
  modules: SearchModule[];
  onTickerClick?: () => void;
  showTag: boolean;
  tag?: SearchItem;
  thinUI?: boolean;
}

export const SearchLinkingIcon: React.FC<SearchLinkingIconProps> = props => {
  const linkingModule = useLinkingSearchModule();
  const groupId = props.tag?.moduleId === linkingModule.id ? (props.tag as LinkingSearchItem).data.linkId : null;
  const linking = useTickerLinking(groupId);

  const renderTag = () => {
    const renderer = props.tag && props.modules.find(m => m.id === props.tag?.moduleId)?.tag.render?.(props.tag);
    if (renderer?.type === 'text') {
      return (
        <SearchTag>
          {renderer.icon ? <SearchTagIcon>{renderer.icon}</SearchTagIcon> : undefined} {renderer.text}
        </SearchTag>
      );
    } else if (renderer?.type === 'custom') {
      return renderer.jsx;
    } else {
      return <SearchTag> Unsupported Tag </SearchTag>;
    }
  };
  return (
    <>
      <TooltipButton className={`TUTORIAL_WidgetContainer-Settings`}>
        <SearchIconWrapper $tooltipColor={linking?.currentColor}>
          <SmallSearch />
        </SearchIconWrapper>
      </TooltipButton>

      <SearchTextWrapper>{props.showTag && renderTag()}</SearchTextWrapper>
    </>
  );
};

const SearchIconWrapper = styled.div<{ $tooltipColor?: WidgetLinkHue | string }>`
  display: flex;
  padding: 0 8px;
  ${SmallSearch} {
    fill: ${props => props.theme.colors.accent};
  }
  background: ${props =>
    props.$tooltipColor != null
      ? isString(props.$tooltipColor)
        ? css`
            ${props.$tooltipColor}
          `
        : css`color-mix(in srgb, ${hueToColor(props.$tooltipColor)}, ${props.theme.colors.backgroundInactive} 50%)`
      : props.theme.colors.background};
  height: 100%;
  align-items: center;
`;

const SearchTextWrapper = styled.div`
  padding-left: 8px;
  align-self: center;
  color: ${props => props.theme.colors.foreground};
  background: ${props => props.theme.colors.background};
  line-height: initial;
`;
